import { chrome } from "./chrome";
import type { ContactSpiel } from "./types";

export const contact: ContactSpiel = {
  heading: "Tell us the situation",
  subheading:
    "Name, email, what's on fire or what you want built, and your timeline.",
  fields: {
    name: {
      label: "Name",
      placeholder: "Your name",
    },
    email: {
      label: "Email",
      placeholder: "you@company.com",
    },
    situation: {
      label: "Situation",
      placeholder: "What's on fire, or what you want built",
    },
    timeline: {
      label: "Timeline",
      placeholder: "When you need this moving",
    },
  },
  submit: "Send",
  sending: "Sending…",
  fieldRequired: "Required",
  fieldEmailInvalid: "That doesn't look like an email.",
  success: "Got it. We'll be in touch.",
  error: "Something went wrong. Try email instead.",
  mailtoSubjectPrefix: "DEVARM inquiry from",
};

export const SUBMIT_LEAD_URL =
  import.meta.env.VITE_SUBMIT_LEAD_URL || "/api/submitLead";

export const contactEmail = chrome.email;
